<section class="form_section">

    <div class="dialog-header">
      <button mat-icon-button (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <h2 class="titulo">Dicom <span 
     
        (click)="getReportEquifaxScoring(data)" class="span_header" matTooltip="Actualizar">
        <i-tabler class="icon-20" name="refresh">
        </i-tabler>  
      </span></h2>

    <div class="spinner" style="display: flex; justify-content: center;" *ngIf="historialDicom == 0">
        <mat-spinner [diameter]="60"></mat-spinner>
    </div>

    <div *ngIf="historialDicom == 2">
        <div class="tab">
            <table class="content-table"> 
                <thead> 
                    <tr> 
                        <th> Puntaje </th>
                        <th> Deuda $ </th> 
                        <th> Fecha Consulta </th>
                        <th> Reporte </th>
                    </tr>
                </thead>
                <tbody> 
                    <tr> 
                        <td>{{ puntaje }}</td>
                        <td>{{ deuda | currency:'CLP':'symbol' }}</td>
                        <td>{{ fechaDeuda | date : "dd/MM/yyyy" }}</td>
                        <td>                        
                            <a href="{{ pathUrlDicom }}" target="_blank" style="font-weight: normal; color:#34425a"><mat-icon
                            matSuffix class="dicomReport">feed</mat-icon></a>
                        </td>
                    </tr>
                </tbody> 
            </table>
        </div>
    </div>

    <div class="info" *ngIf="historialDicom == 1">
        <h3>Sin Consultas</h3>
    </div>

    <!-- <div *ngIf="historialDicom != 0" class="btnNuevaC">
        <button (click)="getReportEquifaxScoring(data)" mat-raised-button color="primary">{{historialDicom ? 'Nueva Consulta' : 'Consultar'}}</button>
    </div> -->

</section>